export default __webpack_public_path__ + "static/media/withdrawals-active.d4de9708.svg";